import { setAlert } from "../../alert";
import { SET_PROPERTY_FIELDS } from "../../../types";
import { handleError } from "../../error";

export const calcPropertyOccupiedVacantSpace = () => async(
    dispatch,
    getState
) => {
    const warnings = [];

    try {
        const { properties: { propertyFields } } = getState();
        const newPropertyFields = { ...propertyFields };
        const Vacant = "7";

        const {
            property_management_leased_space,
            building_size,
            property_management_occupancy_status
        } = propertyFields;

        let leasedSpace = parseFloat(property_management_leased_space) || 0;
        let buildingSize = parseFloat(building_size) || 0;
        let occupiedSpace = parseFloat(
            ((leasedSpace / buildingSize) * 100).toFixed(2)
        );
        console.debug({
            leasedSpace,
            buildingSize,
            occupiedSpace
        });

        // LEASED SPACE == 0: ASSET MUST BE MARKED VACANT
        // "7 - VACANT" IS THE ONLY VALID OPTION
        // LEASED SPACE >= 0: VACANT IS NO LONGER AN OPTION; ALL OTHER OPTIONS ARE ENABLED.
        if (
            occupiedSpace <= 0 &&
            property_management_occupancy_status !== Vacant
        ) {
            warnings.push(
                `Leased Space is ${occupiedSpace}%. Occupancy Status is set to Vacant`
            );
            newPropertyFields.property_management_occupancy_status = Vacant;
        }
        else if (
            occupiedSpace > 0 &&
            property_management_occupancy_status === Vacant
        ) {
            warnings.push(
                `Leased Space is ${occupiedSpace}%. Please select new Occupancy Status!`
            );
            newPropertyFields.property_management_occupancy_status = "";
        }

        if (leasedSpace > buildingSize) {
            warnings.push(
                `Leased Space can not be bigger than Building Area. Re-calculate to maximum allowed!`
            );

            /* Set lease space equal to building size */
            newPropertyFields.property_management_leased_space = buildingSize;
            leasedSpace = buildingSize;

            /* give occuped max % of 100 */
            occupiedSpace = 100;
        }

        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: {
                ...newPropertyFields,
                property_management_occupied_space: !isFinite(occupiedSpace) ?
                    0 :
                    occupiedSpace,
                property_management_vacant_space: buildingSize - leasedSpace
            }
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
    finally {
        warnings.map(msg => dispatch(setAlert(msg, "info")));
    }
};